import { get, orderBy } from 'lodash'

import { track } from 'lib/segmentTracker/Segment'
import { TAResponseProps } from 'types/TextAnalysis'

export const trackActions = (actionName: string, actionInfo: any) => {
  const { featureName = '' } = actionInfo || {}
  track(actionName, {
    featureName: featureName,
    ...actionInfo,
  })
}

export const capitalize = (string: string) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : ''
}

export const sortByDate = (
  list: TAResponseProps[],
  key: string,
  sort: ('asc' | 'desc')[],
) => {
  return orderBy(list, [(obj) => new Date(get(obj, key))], sort)
}
